import Locked from "@/components/Icons/customIcons/Locked"
import Button from "@/components/shared/Button"
import Typography from "@/components/shared/Typography"
import { ROUTES } from "@/conf"
import { useRouter } from "next/router"
import { useTranslation } from "react-i18next"

export const BonusLockedRewardModal = () => {
  const router = useRouter()

  const { t } = useTranslation("common")

  const handleConfirm = async () => {
    router.push(`${ROUTES.map}?cartoon=${router.query.slug}`)
  }

  return (
    <div className="flex flex-col">
      <div className="mb-4">
        <Locked />
      </div>
      <Typography type="h4" className=" mb-2 text-primary-700">
        {t("bonusLockedRewardModal.title")}
      </Typography>

      <Typography type="l" className="mb-8 text-primary-400">
        {t("bonusLockedRewardModal.text")}
      </Typography>

      <div className="flex w-full flex-row justify-between gap-2">
        <Button color="primary" onClick={handleConfirm} fullWidth>
          {t("showOnMap")}
        </Button>
      </div>
    </div>
  )
}
